var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { OnboardingApi } from './apis/onboarding-api.interface';
let OnBoardingRepositoryImpl = class OnBoardingRepositoryImpl {
    constructor(_onboardingApi) {
        this._onboardingApi = _onboardingApi;
    }
    async getSuggestCompany() {
        const res = await this._onboardingApi.getSuggestCompanyList();
        const result = res.map((item) => ({
            name: item.name,
            companyId: item.company_id,
            nameCn: item.name_cn,
            nameEn: item.name_en,
        }));
        return result;
    }
    async createSpaceInfo(params) {
        const res = await this._onboardingApi.createSpaceInfo(params);
        const result = {
            spaceId: res.space_id,
            firstFolderId: res.first_folder_id,
        };
        return result;
    }
    async getAssignCompany(params) {
        const res = await this._onboardingApi.getAssignCompany(params);
        const result = res.map((item) => {
            return {
                ans: {
                    enName: item.ans.en_name,
                    hitName: item.ans.hit_name,
                    id: item.ans.id,
                    label: item.ans.label,
                    number: item.ans.number,
                },
                ansId: item.ans_id,
                count: item.count,
                hitName: item.hit_name,
                type: item.type,
                value: item.value,
            };
        });
        return result;
    }
};
OnBoardingRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(OnboardingApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof OnboardingApi !== "undefined" && OnboardingApi) === "function" ? _a : Object])
], OnBoardingRepositoryImpl);
export { OnBoardingRepositoryImpl };
